export default __webpack_public_path__ + "994a516aa55ef03bc71e9b9e5ad4c7c3.png";